module.exports = __webpack_public_path__ + "static/media/accept.cd9dff66.svg";